import React, { FC } from 'react';
import { Person1 } from '~/assets';
import { Example4 } from '~/assets/png/examples';
import { TextBubble } from '~/components/Molecules';
import {
  Centralizer,
  ExampleImage,
  ExampleImageWrapper,
  FeedbackWrapper,
  PersonImage,
  PersonImageWrapper,
  ReviewWrapper,
  Section,
} from './styles';

export type FrameProps = {
  bubbleText?: string;
  exampleImage?: string;
  reviwerImage?: string;
  id?: string;
  isShowing?: boolean;
};

const Frame: FC<FrameProps> = ({
  bubbleText = 'Simplesmente incrível!! Fizemos uma festa no final do ano em nossa empresa e contratamos a LeDolce. O resultado final foi incrível, todo mundo que estava presente no evento gostou bastante dos doces!',
  exampleImage = Example4,
  reviwerImage = Person1,
  id,
  isShowing,
}) => (
  <Section id={id}>
    <Centralizer>
      <FeedbackWrapper>
        <ExampleImageWrapper isShowing={isShowing}>
          <ExampleImage src={exampleImage} />
        </ExampleImageWrapper>
        <ReviewWrapper isShowing={isShowing}>
          <PersonImageWrapper>
            <PersonImage src={reviwerImage} />
          </PersonImageWrapper>
          <TextBubble bubbleText={bubbleText} />
        </ReviewWrapper>
      </FeedbackWrapper>
    </Centralizer>
  </Section>
);

export default Frame;
